class ProductZoom {
  constructor() {
    if (customElements.get('flickity-carousel')) {
      this.init();
    } else {
      document.addEventListener('flickity-carousel:ready', () => this.init());
    }
  }

  init() {
    this.carousel = document.querySelector('.product__media-list');
    this.mediaListWrapper = document.querySelector('.product__media-list-wrapper');
    this.zoomButton = this.createZoomButton();
    this.zoomWrapper = this.createZoomWrapper();
    this.isMobile = window.innerWidth < 749;
    
    // Bind methods
    this.handleImageZoom = this.handleImageZoom.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleZoomedClick = this.handleZoomedClick.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    
    if (this.mediaListWrapper) {
      this.mediaListWrapper.appendChild(this.zoomButton);
      this.mediaListWrapper.appendChild(this.zoomWrapper);
      this.initFlickity();
    }
  }

  createZoomWrapper() {
    const wrapper = document.createElement('div');
    wrapper.className = 'product__media-zoom-wrapper';
    wrapper.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 3;
      display: none;
      cursor: zoom-out;
      background-repeat: no-repeat;
      background-size: ${this.isMobile ? 'contain' : '200%'};
      background-position: center center;
      touch-action: none;
    `;
    return wrapper;
  }

  async initFlickity() {
    const waitForFlickity = () => {
      if (this.carousel && this.carousel.flickityInstance) {
        this.flickityInstance = this.carousel.flickityInstance;
        this.bindEvents();
      } else {
        setTimeout(waitForFlickity, 100);
      }
    };
    
    waitForFlickity();
  }

  createZoomButton() {
    const button = document.createElement('button');
    button.className = 'zoom-button';
    button.setAttribute('type', 'button');
    button.innerHTML = `
      <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 9V4M9 9V14M9 9H4M9 9H14" stroke="currentColor" stroke-width="2"/>
      </svg>
    `;
    return button;
  }

  bindEvents() {
    this.zoomButton.addEventListener('click', (e) => {
      e.stopPropagation();
      const activeSlide = document.querySelector('.product__media-item.is-selected');
      if (activeSlide) {
        const imageWrapper = activeSlide.querySelector('.product__media-image-wrapper');
        if (imageWrapper) {
          const rect = imageWrapper.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;
          this.handleImageZoom(imageWrapper, { x, y });
        }
      }
    });

    this.zoomWrapper.addEventListener('click', this.handleZoomedClick);
    this.zoomWrapper.addEventListener('mousemove', this.handleMouseMove);
    this.zoomWrapper.addEventListener('mouseleave', this.handleMouseLeave);
    
    // Dodaj obsługę zdarzeń dotykowych
    this.zoomWrapper.addEventListener('touchmove', this.handleTouchMove, { passive: false });
    this.zoomWrapper.addEventListener('touchend', this.handleTouchEnd);
  }

  handleImageZoom(imageContainer = null, initialPosition = null) {
    if (!imageContainer) {
      this.zoomWrapper.style.display = 'none';
      this.zoomWrapper.style.backgroundImage = 'none';
      this.updateZoomButtonIcon(false);
      return;
    }

    const zoomUrl = imageContainer.getAttribute('data-zoom-image');
    
    if (this.zoomWrapper.style.display === 'none') {
      const img = new Image();
      img.onload = () => {
        this.zoomWrapper.style.backgroundImage = `url('${zoomUrl}')`;
        
        if (initialPosition && !this.isMobile) {
          this.zoomWrapper.style.backgroundPosition = `${initialPosition.x}% ${initialPosition.y}%`;
        } else {
          this.zoomWrapper.style.backgroundPosition = '50% 50%';
        }
        
        this.zoomWrapper.style.display = 'block';
        this.updateZoomButtonIcon(true);
      };
      img.src = zoomUrl;
    } else {
      this.zoomWrapper.style.display = 'none';
      this.zoomWrapper.style.backgroundImage = 'none';
      this.updateZoomButtonIcon(false);
    }
  }

  handleZoomedClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.zoomWrapper.style.display === 'block') {
      this.handleImageZoom();
    }
  }

  handleMouseMove(e) {
    const rect = this.zoomWrapper.getBoundingClientRect();
    
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    
    this.zoomWrapper.style.backgroundPosition = `${x}% ${y}%`;
  }

  handleMouseLeave() {
    this.zoomWrapper.style.display = 'none';
    this.zoomWrapper.style.backgroundImage = 'none';
    this.updateZoomButtonIcon(false);
  }

  updateZoomButtonIcon(isZoomed) {
    this.zoomButton.innerHTML = isZoomed ? `
      <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 9H14" stroke="currentColor" stroke-width="2"/>
      </svg>
    ` : `
      <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 9V4M9 9V14M9 9H4M9 9H14" stroke="currentColor" stroke-width="2"/>
      </svg>
    `;
  }

  handleTouchMove(e) {
    e.preventDefault(); // Zapobiega przewijaniu strony
    if (e.touches.length === 1) {
      const touch = e.touches[0];
      const rect = this.zoomWrapper.getBoundingClientRect();
      
      const x = ((touch.clientX - rect.left) / rect.width) * 100;
      const y = ((touch.clientY - rect.top) / rect.height) * 100;
      
      this.zoomWrapper.style.backgroundPosition = `${x}% ${y}%`;
    }
  }

  handleTouchEnd(e) {
    if (e.touches.length === 0) {
      // Opcjonalnie: możesz dodać dodatkową logikę dla zakończenia dotyku
    }
  }
}

// Inicjalizacja
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ProductZoom());
} else {
  new ProductZoom();
} 